export const groupSearchParams = (group: string): string => {
	if (group.trim().length > 0) {
		return decodeURIComponent(group.trim())
	}
	return ''
}